// import { CanDeactivateFn } from '@angular/router'
// import { Observable } from 'rxjs'

// /** Our Route Guard as a Function */
// export const canDeactivateFormComponent: CanDeactivateFn<DeactivatableComponent> = (
//   component: DeactivatableComponent
// ) => {
//   if (component.canDeactivate) {
//     return component.canDeactivate()
//   }
//   return true
// }

// export interface DeactivatableComponent {
//   canDeactivate: () => boolean | Observable<boolean>
// }

import { Injectable } from '@angular/core'

import { MatDialog } from '@angular/material/dialog'
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component'
import { Observable, of } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'
import { DialogService } from '../services/dialog.service'
import { UnsavedChangesService } from '../services/unsaved.changes.service'
import { KeySystemNavConfig } from '../configuration/key.system.nav.config'

export interface DeactivatableComponent {
  canDeactivate: () => boolean | Observable<boolean>
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard  {
  constructor(
    private dialog: MatDialog,
    private dialogService: DialogService,
    private unsavedChangesService: UnsavedChangesService,
    private keySystemNavConfig: KeySystemNavConfig
  ) {}

  /* istanbul ignore next */
  canDeactivate(component: DeactivatableComponent): Observable<boolean> | Promise<boolean> | boolean {
    if (component.canDeactivate) {
      const canDeactivate = component.canDeactivate()
      if (typeof canDeactivate === 'boolean' && canDeactivate === false) {
        return this.showConfirmationDialog()
      } else if (canDeactivate instanceof Observable) {
        return canDeactivate.pipe(
          switchMap((result) => {
            console.log('result', result)
            if (result === false) {
              return this.showConfirmationDialog()
            }
            return of(true)
          })
        )
      } else {
        return canDeactivate
      }
    }
    return true
  }

  // Allows naviagtion to check for unsaved changes
  /* istanbul ignore next */
  hasUnsavedChanges(): boolean {
    return this.unsavedChangesService.hasUnsavedChanges()
  }

  /* istanbul ignore next */
  private showConfirmationDialog(): Promise<boolean> {
    let data = {
      title: 'Unsaved Changes',
      message: `You are about to leave when you have unsaved changes. If you wish to continue without saving, your changes will be lost.`,
      cancel: 'Leave without Saving',
      confirm: 'Stay on Page',
      showCancel: true,
      reasonRequired: false,
    }
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, data)
    return dialogRef
      .afterClosed()
      .toPromise()
      .then((result) => {
        if (result.confirmed) {
          //Stay on Page
          return false
        } else {
          //Leave without Saving
          return true
        }
      })
  }
}
